import { Component, OnInit, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatTooltip } from "@angular/material/tooltip";
import { NgForOf, NgIf, NgStyle } from "@angular/common";
import { FormsModule } from "@angular/forms";
@Component({
    selector: 'app-star-rating',
    imports: [
        NgForOf,
        NgIf,
        NgStyle,
        MatIconModule,
        MatInputModule,
        MatButtonModule,
        MatTooltip,
        FormsModule
    ],
    standalone: true,
    templateUrl: './star-rating.component.html',
    encapsulation: ViewEncapsulation.Emulated
})
export class StarRatingComponent implements OnInit {

  @Input('rating') rating: number = 0;
  @Input('starCount') starCount: number = 5;
  @Output() ratingUpdated: EventEmitter<number> = new EventEmitter();

  snackBarDuration: number = 2000;
  ratingArr: number[] = [];

  constructor() {
  }

  ngOnInit() {
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }

  public onClick(rating:number) {
    this.ratingUpdated.emit(rating);
    return false;
  }

  public showIcon(index:number) {
    if (this.rating >= index + 1) {
      return 'star';
    } else {
      return 'star_border';
    }
  }
}